<h4 class="info-top"><i class="ft-user"></i> Gestor Documental</h4>
<div class="row">
  <div class="col-12" *ngIf="active">
    <form class="form  form-horizontal striped-rows form-bordered" novalidate="" (ngSubmit)="Guardar()" #c="ngForm" autocomplete="off">
      <div class="form-body">
        <div class="form-group row">
          <label class="col-md-3 label-control">Tipo Documento</label>
          <div class="col-md-5">
            <input [(ngModel)]='tipo' type="text"  class="form-control width-input" name="tipo">
          </div>
          <div class="col-md-4">
            <button type="submit" class="btn btn-raised btn-success">{{edit ? 'Editar' : 'Crear'}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="table-responsive">
    <table class="table">
      <thead>
      <tr class="d-flex">
        <th class="col-3" scope="col">Tipo</th>
        <th class="col-3" scope="col">Alumno</th>
        <th class="col-3" scope="col">Empleado</th>
        <th class="col-3" scope="col">
      Agregar Tipo Documento <br> <i class="ft-plus-circle font-medium-3 mr-2 text-success"(click)="abrir()"></i>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr class="d-flex" *ngFor="let tip of tipos; let i = index">
        <td class="col-3">{{tip.tipo}}</td>
        <td class="col-3">
          <mat-checkbox (change)="alumno(i)" [(ngModel)]="tip.alumno"></mat-checkbox>
        </td>
        <td class="col-3">
          <mat-checkbox (change)="personal(i)"[(ngModel)]="tip.personal"></mat-checkbox>
        </td>
        <td class="col-3">
          <ul class="list-inline">
            <li class="list-inline-item danger p-0" (click)="editar(tip.id, tip.tipo, i)">
              <i class="fa fa-edit font-medium-3 mr-2"></i>
            </li>
          </ul>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
